/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrganizationPlanDetailFromJSON, OrganizationPlanDetailToJSON } from './OrganizationPlanDetail';
export function GetOrganizationPaymentPlanResponseDataFromJSON(json) {
    return GetOrganizationPaymentPlanResponseDataFromJSONTyped(json, false);
}
export function GetOrganizationPaymentPlanResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        plan: OrganizationPlanDetailFromJSON(json['plan'])
    };
}
export function GetOrganizationPaymentPlanResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        plan: OrganizationPlanDetailToJSON(value.plan)
    };
}
